"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTextbox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FormLabel = require("../FormLabel");
var _FormTextbox = require("./FormTextbox.styled");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _excluded = ["ariaLabel", "labelText", "helperText", "required", "hasError", "disabled", "errorMessage", "testId", "id", "className"];
var FormTextbox = exports.FormTextbox = function FormTextbox(_ref) {
  var ariaLabel = _ref.ariaLabel,
    labelText = _ref.labelText,
    helperText = _ref.helperText,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    errorMessage = _ref.errorMessage,
    testId = _ref.testId,
    id = _ref.id,
    className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_FormTextbox.StyledFormGroup, {
    disabled: disabled,
    className: className
  }, labelText && /*#__PURE__*/_react["default"].createElement(_FormLabel.FormLabel, (0, _extends2["default"])({
    label: labelText,
    labelFor: id,
    required: required,
    "data-testid": "".concat(testId, "_label")
  }, ariaLabel && {
    ariaLabel: "".concat(ariaLabel, "_label")
  })), /*#__PURE__*/_react["default"].createElement(_FormTextbox.StyledInput, (0, _extends2["default"])({
    id: id,
    hasError: hasError,
    disabled: disabled,
    "data-testid": testId,
    "aria-label": ariaLabel
  }, hasError && {
    'aria-describedby': errorMessage
  }, props)), hasError && /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex mt-1"
  }, /*#__PURE__*/_react["default"].createElement(_FormTextbox.StyledErrorIcon, {
    icon: _freeSolidSvgIcons.faTriangleExclamation
  }), /*#__PURE__*/_react["default"].createElement(_FormTextbox.StyledFormMessage, {
    type: "error",
    id: "errorMessage",
    "data-testid": "".concat(testId, "_error"),
    text: errorMessage
  })), helperText && /*#__PURE__*/_react["default"].createElement(_reactstrap.FormText, null, helperText));
};
FormTextbox.propTypes = {
  labelText: _propTypes["default"].string,
  helperText: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  hasError: _propTypes["default"].bool,
  testId: _propTypes["default"].string,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired
};